import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/onboarding');
  };

  return (
    <div className="landing-page">
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo">
            <div className="logo-icon">📈</div>
            <h2>Autopilot</h2>
          </div>
          <div className="nav-links">
            <a href="#features">Features</a>
            <a href="#about">About</a>
            <button className="nav-cta" onClick={handleGetStarted}>
              Get Started
            </button>
          </div>
        </div>
      </nav>

      <main className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="badge-icon">🚀</span>
              <span>Start your investment journey today</span>
            </div>
            <h1 className="hero-title">
              The smart way to <span className="gradient-text">invest your money</span>
            </h1>
            <p className="hero-subtitle">
              Practice trading with $1M in virtual funds. Build your portfolio, 
              track performance, and learn investment strategies risk-free.
            </p>
            <div className="hero-actions">
              <button className="btn-primary" onClick={handleGetStarted}>
                Start Trading Now
              </button>
              <button className="btn-secondary">
                Watch Demo
              </button>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">$1M</span>
                <span className="stat-label">Virtual Funds</span>
              </div>
              <div className="stat">
                <span className="stat-number">10+</span>
                <span className="stat-label">Popular Stocks</span>
              </div>
              <div className="stat">
                <span className="stat-number">Real-time</span>
                <span className="stat-label">Market Data</span>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="dashboard-preview">
              <div className="preview-header">
                <div className="preview-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="preview-title">Portfolio Dashboard</div>
              </div>
              <div className="preview-content">
                <div className="preview-portfolio-value">
                  <div className="portfolio-amount">$1,247,892</div>
                  <div className="portfolio-change positive">+$12,847 (+1.04%)</div>
                </div>
                <div className="preview-chart">
                  <div className="chart-line"></div>
                  <div className="chart-points">
                    <div className="point"></div>
                    <div className="point"></div>
                    <div className="point"></div>
                    <div className="point"></div>
                    <div className="point active"></div>
                  </div>
                </div>
                <div className="preview-holdings">
                  <div className="holding-item">
                    <span className="holding-ticker">AAPL</span>
                    <span className="holding-value">$45,230</span>
                    <span className="holding-change positive">+2.3%</span>
                  </div>
                  <div className="holding-item">
                    <span className="holding-ticker">GOOGL</span>
                    <span className="holding-value">$38,450</span>
                    <span className="holding-change negative">-1.2%</span>
                  </div>
                  <div className="holding-item">
                    <span className="holding-ticker">TSLA</span>
                    <span className="holding-value">$52,100</span>
                    <span className="holding-change positive">+4.7%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <section className="features" id="features">
        <div className="features-container">
          <h2 className="features-title">Everything you need to succeed</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Real-time Trading</h3>
              <p>Buy and sell stocks with simulated real-time market data and instant execution.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Portfolio Tracking</h3>
              <p>Monitor your holdings, track performance, and analyze your investment strategy.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Market Analysis</h3>
              <p>Access historical data, price charts, and market insights to make informed decisions.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Risk-free Environment</h3>
              <p>Practice trading strategies without real financial risk using virtual funds.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>Autopilot</h3>
              <p>Invest smarter. Grow faster.</p>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Product</h4>
                <a href="#features">Features</a>
                <a href="#pricing">Pricing</a>
                <a href="#demo">Demo</a>
              </div>
              <div className="footer-column">
                <h4>Support</h4>
                <a href="#help">Help Center</a>
                <a href="#contact">Contact</a>
                <a href="#status">Status</a>
              </div>
              <div className="footer-column">
                <h4>Legal</h4>
                <a href="#privacy">Privacy</a>
                <a href="#terms">Terms</a>
                <a href="#security">Security</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Matsa. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
